import { api } from 'common';

import { AdvancedFhirFormFields } from './FormFields';
import { ADVANCED_FHIR_DOCUMENTATION_MARKDOWN } from './documentation';
import { type BlockConfigProps } from '../../types';
import { SharedRestNodeOutputContent } from '../Rest/Shared/OutputContent';
import { sharedRestBlockDefaultConfig } from '../Rest/Shared/constants';

type AdvancedFhirBlockConfig = api.FlowDefinition.AdvancedFhirBlock['config'];

export const advancedFhirBlockConfig: BlockConfigProps<AdvancedFhirBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'fhirV2',
  defaultConfig: {
    ...sharedRestBlockDefaultConfig,
    apiInstanceId: '',
    path: '/',
    method: api.Orchestrator.ApiInstanceFhir.ApiInstanceFhirMethod.GET,
  },
  configFields: {
    schema: api.FlowDefinition.AdvancedFhirBlockConfigSchema,
    FormFields: AdvancedFhirFormFields,
  },
  OutputContentComponent: SharedRestNodeOutputContent,
  documentationMarkdown: ADVANCED_FHIR_DOCUMENTATION_MARKDOWN,
};
